import { IVehicleTransfer } from "@/types/vehicleTransfer.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";
import { getCompanyId } from "./company.api";

const API_URL = `${import.meta.env.VITE_API_URL}/vehicle-transfer`;

const makeRequestDebounced = createDebounce(makeRequest, 250);

export async function createVehiclesTransfer(vehicleData) {
  const data = {
    ...vehicleData,
    companyId: getCompanyId(),
  };
  const url = `${API_URL}/`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IVehicleTransfer>
  >;
}

export async function getVehiclesTransfers(filters: {
  page: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}) {
  const params = new URLSearchParams({
    page: filters.page.toString(),
    limit: (filters.itemsPerPage || 10).toString(),
  });

  if (filters.search) {
    params.append("search", filters.search);
  }
  if (filters.status) {
    params.append("status", filters.status);
  }

  const url = `${API_URL}/all?${params.toString()}`;
  const options = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  return makeRequest(url, options) as Promise<
    ApiResponseType<IVehicleTransfer[]>
  >;
}

export async function updateVehicleTransfer(
  transferId: string,
  payload: Partial<IVehicleTransfer>
) {
  const url = `${API_URL}/${transferId}`;

  const options = {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };

  return makeRequest(url, options);
}
